import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const Grid = React.forwardRef(({ className, cols = 1, gap = 4, responsive = true, ...props }, ref) => {
    const colsClasses = {
        1: 'grid-cols-1',
        2: responsive ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-2',
        3: responsive ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' : 'grid-cols-3',
        4: responsive ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4' : 'grid-cols-4',
        5: responsive ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5' : 'grid-cols-5',
        6: responsive ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6' : 'grid-cols-6',
        12: responsive ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 2xl:grid-cols-12' : 'grid-cols-12'
    };
    const gapClasses = {
        1: 'gap-1',
        2: 'gap-2',
        3: 'gap-3',
        4: 'gap-4',
        5: 'gap-5',
        6: 'gap-6',
        8: 'gap-8',
        10: 'gap-10',
        12: 'gap-12'
    };
    return (_jsx("div", { ref: ref, className: cn('grid', colsClasses[cols], gapClasses[gap], className), ...props }));
});
Grid.displayName = 'Grid';
export { Grid };
